module.exports = __webpack_public_path__ + "img/grand-palm-family.4b44bdf9.jpg";